import React from "react";
import { Col, Row } from "reactstrap";

class Quiz extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      dataSet: this.props.quizData,
      correct: 0,
      incorrect: 0,
      attempted: 0,
      completed: false,
    };
  } // end constructor

  handleClick = (choice) => {
    this.setState({ attempted: this.state.attempted + 1 });
    if (choice === this.state.dataSet[this.state.current].correct) {
      this.setState({ correct: this.state.correct + 1 });
    } else {
      this.setState({ incorrect: this.state.incorrect + 1 });
    }
    if (this.state.current === this.state.dataSet.length - 1) {
      this.setState({ completed: true });
    } else {
      this.setState({ current: this.state.current + 1 });
    }
  };

  render() {
    return (
      <div>
        <h1 className="tc">{this.state.dataSet[this.state.current].topic}</h1>
        <h2 className="tc countQuestion">
          {this.state.attempted} out of {this.state.dataSet.length}
        </h2>

        {this.state.completed ? (
          <div className="tc">
            <Row>
              <Col sm="6">
                {" "}
                <h4 className="correctBox green">
                  Correct: {this.state.correct}
                </h4>
              </Col>

              <Col sm="6">
                <h4 className="red incorrectBox">
                  Incorrect: {this.state.incorrect}
                </h4>
              </Col>
            </Row>

            <br />
          </div>
        ) : (
          <div className="quizContent">
            <h4>
              <b>
                <strong>
                  {this.state.dataSet[this.state.current].question}
                </strong>
              </b>
            </h4>
            {this.state.dataSet[this.state.current].options.map(
              (item, index) => {
                return (
                  <Row onClick={() => this.handleClick(index)}>
                    <Col sm="1">
                      {" "}
                      <div className="listDot" />
                    </Col>
                    <Col sm="11">
                      <div className="listText">{item}</div>
                    </Col>
                  </Row>
                );
              }
            )}
          </div>
        )}
      </div>
    );
  }
}

export default Quiz;
